export default {
  
  parseSolutions(solutionsJson) {
    // Sample of responses
    // {"has_solutions":true, "solutions":"[['P'=p,'D'=d,'Delta'=[r1]]]"}
    //
    // { "has_solutions": true, "solutions": "[['Delta'=[nott(c1),p2,r3,c1,r1]],['Delta'=[nott(c1),c1,nott(p2),p2,r3,r1]],['Delta'=[nott(p2),p2,r3,r1]],['Delta'=[nott(c1),c1,nott(p2),p2,r3,r1]],['Delta'=[nott(c1),p2,r3,c1,r1]]]" }
    if(!solutionsJson.has_solutions)
      return []

    let prolog = solutionsJson.solutions
    prolog = prolog.substring(1, prolog.length - 1)

    let sols = prolog.split('],[')
    // [
    //    ['Delta'=[nott(c1),p2,r3,c1,r1]],
    //    ['Delta'=[nott(c1),c1,nott(p2),p2,r3,r1]],
    //    ['Delta'=[nott(p2),p2,r3,r1]],
    //    ['Delta'=[nott(c1),c1,nott(p2),p2,r3,r1]],
    //    ['Delta'=[nott(c1),p2,r3,c1,r1]
    // ]
    const solutions = []
    for (let index=0; index<sols.length; index++) {
      let sol = sols[index]
      if(index === 0) {
        // remove first braket
        sol = sol.substring(1, sol.length)
      }
      if(index === sols.length - 1) {
        // remove last braket
        sol = sol.substring(0, sol.length - 1)
      }
      solutions.push(sol)
    }

    return solutions
  }

 

}